









































































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import { ResidentModule } from '@/store/modules/resident.module'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import Select from '@/components/Select.vue'
import ErrorMessages from '@/components/ErrorMessages.vue'
import Input from '@/components/inputs/Input.vue'
import { NoCache } from '@/decorators/NoCache'
import { User } from '@/classes/User'
import Api from '@/api'
import { PaymentsModule } from '@/store/modules/payments.module'
import { TransactionsModule } from '@/store/modules/transactions.module'
import Card from '@/components/Card.vue'
import { minus, plus } from '@/utils/helpers'
import MoneyInputV3 from '@/components/inputs/MoneyInputV3.vue'
import moment from 'moment'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import Table from '@/components/tables/Table.vue'
import { getIdFromEntityField, ICalculatedResidentAutoApplyPaymentItemDTO, ITransactionToPay } from '@zunta/configurations'
import { FacilityModule } from '@/store/modules/facility.module'

@Component({
  components: {
    Table,
    Card,
    Input,
    Icon,
    Select,
    ErrorMessages,
    MoneyInputV3
  }
})
export default class EditPayment extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  paymentModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  transactionModuleInstance: TransactionsModule = getModule(TransactionsModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  user: User = Api.getUser() as User

  errors: string[] = []
  filters: any = {}

  lineItems: any[] = []

  isSaving: boolean = false

  config: ITableConfig = {
    usePagination: false,
    useQuery: false,
    fetchFunction: this.filterItems,
    debounceTime: 10,
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: 0; right: 0; z-index: 2;',
      class: 'rounded-top-bottom'
    },
    columns: [
      {
        minWidth: '150px',
        width: 21,
        key: 'transactionName',
        searchKey: 'transactionName',
        label: 'Unpaid Line Item',
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        headClass: 'bt-justify-content-center',
        class: 'text-center',
        minWidth: '140px',
        width: 16,
        key: 'date',
        searchKey: 'date',
        label: 'Date',
        hasSearch: true,
        type: ETableColumnType.dateRange
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '120px',
        width: 16,
        key: 'amount',
        searchKey: 'amount',
        label: 'Amount',
        hasSearch: true,
        type: ETableColumnType.numberRange
      },
      {
        headClass: 'bt-justify-content-center',
        class: 'text-right',
        minWidth: '120px',
        width: 20,
        key: 'distribution',
        searchKey: 'distribution',
        label: 'Distribution',
        hasSearch: true,
        type: ETableColumnType.numberRange
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '120px',
        width: 20,
        key: 'due',
        searchKey: 'due',
        label: 'Balance Due',
        hasSearch: true,
        type: ETableColumnType.numberRange
      },
      {
        minWidth: '50px',
        width: 7,
        key: 'actions',
        type: ETableColumnType.actions
      }
    ]
  }

  async mounted () {
    await this.fetchData()
  }

  async fetchData () {
    await Promise.all([
      this.residentModuleInstance.getResidentPayment(this.paymentId),
      this.paymentModuleInstance.getPaymentTransactions(this.paymentId),
      this.transactionModuleInstance.getResidentTransactions({ residentId: this.residentId, filters: {} }),
      this.paymentModuleInstance.getPaymentPayerTypes(this.resident.facility.id ? this.resident.facility.id : this.resident.facility)
    ])
    this.formatTableData()
  }

  formatTableData () {
    const result: any[] = []
    const facilityTempApply = this.resident.facility.tempApplyPayment
    const effectedTransactions: number[] = []
    if (!this.paymentTransactions.length) {
      this.lineItems = []
      return
    }
    this.paymentTransactions.forEach((transaction: any) => {
      effectedTransactions.push(transaction.transactionEffectiveDate.id)
      const ted = transaction.transactionEffectiveDate
      result.push({
        amount: ted.remainingAmount,
        id: ted.id,
        distribution: transaction.amount,
        previousDistribution: transaction.amount,
        transactionName: ted.payerType.payer_name,
        date: ted.isCredit ? `${ted.effectiveMonth}/${ted.effectiveYear}` : ted.effectiveYear ? `${ted.effectiveMonth}/01/${ted.effectiveYear}` : 'Previous Balance',
        transactionEffectiveDate: ted,
        due: facilityTempApply ? ted.remainingAmount : ted.remainingAmount - transaction.amount,
        isCredit: ted.isCredit,
        payerType: ted.isCredit ? ted.payerType.id : ted.payerType
      })
    })
    this.transactionEffectiveDates.forEach((ted: any) => {
      if (effectedTransactions.includes(ted.id)) {
        return
      }
      result.push({
        amount: ted.remainingAmount,
        id: ted.id,
        distribution: 0,
        previousDistribution: 0,
        transactionName: ted.payerType.payer_name,
        date: ted.isCredit ? `${ted.effectiveMonth}/${ted.effectiveYear}` : ted.effectiveYear ? `${ted.effectiveMonth}/01/${ted.effectiveYear}` : 'Previous Balance',
        transactionEffectiveDate: ted,
        due: ted.remainingAmount,
        isCredit: ted.isCredit,
        payerType: ted.isCredit ? ted.payerType.id : ted.payerType
      })
    })
    this.lineItems = result
    this.recalculateAllDues()
  }

  get availableAutoApplyPaymentItems () {
    const numericFilters = ['due', 'distribution', 'amount']

    return this.lineItems.filter((item: ICalculatedResidentAutoApplyPaymentItemDTO) => {
      if (this.filters.transactionName && (!item.transactionName || !new RegExp(`${this.filters.transactionName.toLowerCase()}`).test(item.transactionName.toLowerCase()))) {
        return false
      }

      for (const numericFilter of numericFilters) {
        if (!this.filters[numericFilter]) {
          continue
        }

        const [startVal, endVal] = this.filters[numericFilter].split(';').map((item: string) => Number(item))
        const itemVal = Number((item as any)[numericFilter]).toFixed(2)

        if (!endVal) {
          if (itemVal.toString().indexOf(startVal.toString()) === -1) {
            return false
          }
        } else if (startVal.toFixed(2) > itemVal || endVal.toFixed(2) < itemVal) {
          return false
        }
      }

      if (this.filters.date && item.date) {
        const [startDate, endDate] = this.filters.date.split(';').map((item: string) => moment(item, 'MM/DD/YYYY'))
        const itemDate = moment(item.date, 'M/YYYY')
        if (itemDate.diff(startDate.startOf('month')) < 0 || itemDate.diff(endDate.startOf('month')) > 0) {
          return false
        }
      }

      return true
    })
  }

  get showDeleteBtn (): boolean {
    return this.lineItems.filter((item: any) => item.isCredit).length >= 2
  }

  get paymentPayerTypes () {
    return this.$store.state.payments.paymentPayerTypes
      ? this.$store.state.payments.paymentPayerTypes
      : []
  }

  get paymentPayerTypesOptions () {
    return this.paymentPayerTypes.map((item: any) => {
      return {
        key: item.payerType.id,
        value: item.payerType.id,
        content: 'Credit for ' + item.payerType.payer_name
      }
    })
  }

  get residentPayment () {
    return this.$store.state.resident.selectedPayment
  }

  get residentId () {
    return this.$route.params.residentId
  }

  get resident () {
    return this.$store.state.resident.selectedResident
  }

  get creditDateOption () {
    const arr = [moment().add(1, 'months').format('M/YYYY')]
    for (let i = 0; i < 24; i++) {
      arr.push(moment().subtract(i, 'months').format('M/YYYY'))
    }
    return arr.map((item: any) => {
      return {
        key: item,
        value: item,
        content: item
      }
    })
  }

  get paymentId () {
    return this.$route.params.paymentId
  }

  get residentName () {
    return this.$store.state.resident.selectedResident.firstName
  }

  get paymentTransactions () {
    return this.$store.state.payments.transactions
  }

  get transactionEffectiveDates () {
    return this.$store.state.transactions.transactions
  }

  get openBalance () {
    return this.$store.state.resident.openBalance
  }

  get autoApplyPayment () {
    return this.$store.state.resident.calculatedAutoApplyPayment
  }

  @NoCache
  get differentBetweenDistributions () {
    if (!this.residentPayment) {
      return 0
    }
    const amount = minus(this.residentPayment.amount, this.totalAmountDistribution)
    return minus(amount, this.surchargeAmount)
  }

  get surchargeAmount () {
    if (!this.residentPayment) {
      return 0
    }
    return this.residentPayment.surcharge ? this.residentPayment.surcharge : 0
  }

  get totalAmountDistribution () {
    return this.lineItems.reduce((total: number, item: any) => plus(total, item.distribution), 0)
  }

  addCredit () {
    this.lineItems.push({
      // @ts-ignore
      isCredit: true,
      date: '',
      payerType: null,
      amount: 0,
      previousDistribution: 0,
      distribution: 0,
      due: 0
    })
  }

  removeItem (index: number) {
    this.lineItems.splice(index, 1)
  }

  findMatchingLineItemsByTed (item: any) {
    const normalizeDate = (date: string) => moment(date, ['M/YYYY', 'M/DD/YYYY']).format('M/YYYY')
    return this.lineItems.filter(li =>
      li !== item &&
      normalizeDate(li.date) === normalizeDate(item.date) &&
      getIdFromEntityField(li.payerType) === getIdFromEntityField(item.payerType)
    )
  }

  prefillCredit (item: any) {
    if (!item.payerType || !item.date) {
      return
    }
    const matchingLineItem = this.findMatchingLineItemsByTed(item)[0] || {}
    item.transactionEffectiveDate = matchingLineItem.transactionEffectiveDate || null
    item.amount = matchingLineItem.amount || 0
    item.due = matchingLineItem.due || 0
    item.distribution = 0
  }

  filterItems (filters: any) {
    this.filters = { ...filters }
  }

  recalculateAllDues () {
    const facilityTempApply = this.resident.facility.tempApplyPayment
    const visited = new Set()

    this.lineItems.forEach((item: any) => {
      if (visited.has(item)) {
        return
      }
      const lineItemsGroup = [item, ...this.findMatchingLineItemsByTed(item)]
      const totalDiffDistribution = lineItemsGroup.reduce((sum: number, li: any) => plus(sum, li.previousDistribution - li.distribution), 0)
      const totalDistribution = lineItemsGroup.reduce((sum: number, li: any) => plus(sum, li.distribution), 0)
      let due = 0
      if (facilityTempApply) {
        due = plus(item.amount, totalDiffDistribution)
      } else {
        due = minus(item.amount, totalDistribution)
      }

      lineItemsGroup.forEach(li => {
        li.due = due
        visited.add(li)
      })
    })

    this.$forceUpdate()
  }

  validate () {
    this.errors = []

    if (this.differentBetweenDistributions !== 0) {
      this.errors.push('Payment amount is not equal distribution total')
    }

    return this.errors.length === 0
  }

  async submit () {
    if (this.isSaving) {
      return
    } else {
      this.isSaving = true
    }
    if (!this.validate()) {
      this.isSaving = false
      return
    }

    const requestData: any = {
      paymentId: this.paymentId,
      residentId: this.residentId
    }
    const transactions: ITransactionToPay[] = []

    this.lineItems.forEach((item) => {
      if (!item.distribution || item.distribution <= 0) {
        return
      }
      transactions.push({
        paymentId: Number(this.paymentId),
        transactionEffectiveDate: item.transactionEffectiveDate && getIdFromEntityField(item.transactionEffectiveDate),
        amount: item.distribution,
        payerType: item.payerType,
        date: item.date,
        isCredit: item.isCredit
      })
    })

    requestData.transactions = transactions

    try {
      const response = await this.paymentModuleInstance.editPayment(requestData)
      if (response === 'OK') {
        await this.$router.push({
          name: 'payment-one-time-success',
          params: {
            residentId: this.residentId,
            paymentId: this.paymentId
          }
        })
        return
      }

      let errorMessage = 'Internal server error'
      if (response.message) {
        errorMessage = response.message
      }
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: errorMessage,
        header: `Edit Payment`,
        icon: 'warning'
      })
    } finally {
      this.isSaving = false
    }
  }

  goBack () {
    this.$locationManager.goBack({ name: 'resident-page-general', params: { id: this.$route.params.residentId } })
  }
}

